import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    const token = getToken()
    if (token) {
      // 让每个请求携带token
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 处理请求错误
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 正常返回数据
    return res
  },
  error => {
    // 处理响应错误
    console.log('err' + error) // for debug
    if (error.response) {
      // 根据状态码处理错误
      if (error.response.status === 401) {
        // 未授权，重定向到登录页
        Message.error('登录已过期，请重新登录')
        router.push('/login')
      } else if (error.response.status === 403) {
        // 禁止访问
        Message.error('您没有权限访问该资源')
      } else {
        // 其他错误
        Message.error(error.response.data.message || '请求失败')
      }
    } else {
      // 请求没有收到响应
      Message.error('网络连接失败，请检查网络')
    }
    return Promise.reject(error)
  }
)

export default service 


// WEBPACK FOOTER //
// ./src/utils/request.js